<template>
  <el-container>
    <el-form ref="ruleForm" :model="ruleForm" label-width="150px" :rules="rules">
      <el-form-item label="当前故障处理人:">
        {{rowData.warning_user_name}}
      </el-form-item>
      <el-form-item label="选择故障处理人:" prop="warning_user_id">
        <el-select v-model="ruleForm.warning_user_id">
          <el-option
            v-for="item in share.userList"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button class="btn_dialog" @click="$emit('tableCloseDialog')">取消</el-button>
        <el-button class="btn_dialog cz" @click="resetForm">重置</el-button>
        <el-button class="btn_dialog qd" @click="confirm">确认</el-button>
      </el-form-item>
    </el-form>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'

export default {
  name: '',
  data () {
    const deviceId = this.rowData.device_id
    return {
      service: 'device_warn_user',
      id_name: 'device_id',
      ruleForm: {
        device_id: deviceId,
        warning_user_id: null
      },
      rules: {
        warning_user_id: [
          { required: true, message: '请选择故障处理人', trigger: 'change' }
        ]
      },
      share: {
        userList: []
      }
    }
  },

  props: ['rowData'],

  created () {
    Backend.filterKeyValueList(this, 'user', '/warning_user/' + this.rowData.warning_user_id, '', '', '', true)
  },

  methods: {
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    confirm () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          Backend.editRow(this, this.ruleForm, undefined, '设备')
        }
      })
    }
  }
}
</script>
